import { render, staticRenderFns } from "./RErrorMessage.vue?vue&type=template&id=47487d70&scoped=true&"
import script from "./RErrorMessage.vue?vue&type=script&lang=js&"
export * from "./RErrorMessage.vue?vue&type=script&lang=js&"
import style0 from "./RErrorMessage.vue?vue&type=style&index=0&id=47487d70&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47487d70",
  null
  
)

export default component.exports